import React, {
  Fragment,
  useContext,
  useEffect,
  useState,
  useRef,
} from "react";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import FormControlLabel from "@mui/material/FormControlLabel";
import Autocomplete from "@mui/material/Autocomplete";
import { AlertContext } from "../../../context/AlertContext";
import { ConfiguracionContext } from "../../../context/ConfiguracionContext";
import Spinner from "../Spinner";
import { AuthContext } from "../../../context/AuthContext";
import { Checkbox } from "primereact/checkbox";
import "../../../assets/css/DataTableDemo.css";
import "primereact/resources/themes/saga-blue/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import { Tag } from "primereact/tag";
import { InputText } from "primereact/inputtext";
import ButtonMui from "@mui/material/Button";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import { Toast } from "primereact/toast";
import { Dialog } from "primereact/dialog";
import { Navigate, useNavigate } from "react-router-dom";
import { saveAs } from "file-saver";
import Menu from "../Menu";
import { InputNumber } from "primereact/inputnumber";
import { jsPDF } from "jspdf";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import { InputMask } from "primereact/inputmask";

export default function ProcesosPagoFacilPagoMisCuentas(props) {
  const [globalFilter, setGlobalFilter] = useState(null);
  const [selectedRow, setSelectedRow] = useState(null);

  const [visibleProceso, setVisibleProceso] = useState(true);
  const [todosLosCobradores, setTodosLosCobradores] = useState(false);
  const [repetirPeriodo, setRepetirPeriodo] = useState(false);
  const [proceso, guardarProceso] = useState(null);
  const [valor, guardarValor] = useState("cuota");
  const [fijo, setFijo] = useState(null);
  const toast = useRef(null);
  const acCobrador = useRef(null);

  let navigate = useNavigate();

  //Context

  const alertContext = useContext(AlertContext);
  const { mensajeAlerta } = alertContext;

  const authContext = useContext(AuthContext);
  const { state, usuarioAutenticado } = authContext;

  const configuracionContext = useContext(ConfiguracionContext);
  const {
    cobradores,
    statusAcceso,
    empresaElegida,
    listadoExcel,
    empresas,
    configuracion,
    obtenerAcceso,
    tiposComprobantes,
    procesos,
    obtenerModulos,
    obtenerCobradores,
    obtenerEmpresas,
    procesoPagoFacil,
    obtenerTiposComprobantes,
  } = configuracionContext;

  useEffect(() => {
    if (state.usuario) {
      obtenerAcceso({
        usuarioId: state.usuario.id,
        layout: "ProcesosPagoFacil",
      });
    }
  }, [state.id]);

  useEffect(() => {
    obtenerEmpresas();
  }, []);

  const exitClick = (e) => {
    navigate("/");
  };

  const onHideProceso = (e) => {
    setVisibleProceso(false);
  };

  const aceptarProceso = async (e) => {
    e.preventDefault();
    //Validar

    if (
      !proceso ||
      proceso.periodo === undefined ||
      proceso.periodo === null ||
      proceso.periodo === 0 ||
      proceso.periodo === ""
    ) {
      mensajeAlerta("Pago Fácil", "El período es necesario !.", "error");
      return;
    }
    confirm1();
  };

  const confirm1 = () => {
    confirmDialog({
      message: "Esta seguro de iniciar el proceso de exportación",
      header: "Confirmación",
      icon: "pi pi-info-circle",
      acceptClassName: "p-button-success",
      closable: false,
      acceptLabel: "Si",
      accept: accept1,
    });
  };

  const accept1 = async () => {
    await procesoPagoFacil({
      proceso,
      empresaElegida,
      usuario: state.usuario.usuario,
    }).then((data) => {
      let elem = document.getElementById("generarProceso");
      elem.click();
    });
  };

  const accesoDenegado = () => {
    mensajeAlerta(
      "Proceso de Impresión",
      "No tiene permiso para acceder a esta pantalla !.",
      "error"
    );
    exitClick();
    return;
  };

  const renderHeaderProceso = () => {
    return (
      <div>
        <Tag
          value={
            empresaElegida && empresas && empresas.length > 0
              ? "Pago Fácil y Pago Mis Cuentas " + empresaElegida.nombre
              : null
          }
        ></Tag>
      </div>
    );
  };

  const renderFooterProceso = () => {
    return (
      <div>
        <ButtonMui
          onClick={aceptarProceso}
          color="primary"
          type="button"
          fullWidth
          variant="contained"
          startIcon={<CheckIcon />}
          autoFocus
        >
          Aceptar
        </ButtonMui>

        <ButtonMui
          onClick={onHideProceso}
          color="secondary"
          type="button"
          fullWidth
          variant="contained"
          startIcon={<CloseIcon />}
          autoFocus
        >
          Cancelar
        </ButtonMui>
      </div>
    );
  };

  const fechaTemplate = (rowData) => {
    return <Fragment>{formatDate(rowData.fecha)}</Fragment>;
  };

  const anuladoTemplate = (rowData) => {
    return (
      <Fragment>
        <Checkbox checked={rowData.anulado}></Checkbox>
      </Fragment>
    );
  };

  function formatDate(input) {
    var datePart = input.match(/\d+/g),
      year = datePart[0],
      month = datePart[1],
      day = datePart[2];
    return day + "/" + month + "/" + year;
  }

  function formatDateReves(input) {
    var datePart = input.match(/\d+/g),
      year = datePart[0],
      month = datePart[1],
      day = datePart[2];
    return year + month + day;
  }

  function formatDateIso(dateString) {
    var allDate = dateString.replace("T", " ");
    allDate = allDate.replace(".", " ");
    allDate = allDate.split(" ");
    var thisDate = allDate[0].split("-");
    var thisTime = allDate[1].split(":");
    var newDate = [thisDate[0], thisDate[1], thisDate[2]].join("");
    var newTime = [thisTime[0], thisTime[1]].join(":");
    return newDate;
  }

  const generar = async () => {
    const pad = (num, size) => num.toString().padStart(size, "0");

    function calcularSiguientePeriodo(fechaBase = new Date()) {
      // Copia la fecha para no modificar el objeto original
      const fechaSiguiente = new Date(fechaBase);

      // Establece el mes al mes actual + 1.
      // JavaScript Date se encarga automáticamente de los años bisiestos y
      // del cambio de año (enero después de diciembre).
      fechaSiguiente.setMonth(fechaSiguiente.getMonth() + 1);

      // Obtiene el mes y le suma 1 (getMonth() devuelve 0-11).
      const mes = (fechaSiguiente.getMonth() + 1).toString().padStart(2, "0");

      // Obtiene el año completo y extrae los últimos dos dígitos.
      const anio = fechaSiguiente.getFullYear().toString().slice(-2);

      return `${mes}/${anio}`;
    }

    const fechaActual = new Date();
    const anioActual = fechaActual.getFullYear();
    const mesActualSinFormato = fechaActual.getMonth() + 1;
    const mesActualFormateado = String(mesActualSinFormato).padStart(2, "0");
    const diaActualSinFormato = fechaActual.getDate();
    const diaActualFormateado = String(diaActualSinFormato).padStart(2, "0");
    const periodyyyymmdd = `${anioActual}${mesActualFormateado}${diaActualFormateado}`;

    const Ultimo = new Date(anioActual, mesActualSinFormato, 0);
    const dayUltimo = pad(Ultimo.getDate(), 2);
    const diezMesSiguiente = new Date(Ultimo);
    diezMesSiguiente.setDate(Ultimo.getDate() + 10);
    const anioActual10 = diezMesSiguiente.getFullYear();
    const mesActual10SinFormato = diezMesSiguiente.getMonth() + 1;
    const mesActual10Formateado = String(mesActual10SinFormato).padStart(
      2,
      "0"
    );
    const diaActual10SinFormato = diezMesSiguiente.getDate();
    const diaActual10Formateado = String(diaActual10SinFormato).padStart(
      2,
      "0"
    );

    const fechaUltimo = new Date(Ultimo);
    const anioUltimo = fechaUltimo.getFullYear();
    const mesUltimoSinFormato = fechaUltimo.getMonth() + 1;
    const mesUltimoFormateado = String(mesUltimoSinFormato).padStart(2, "0");

    const diezMes =
      proceso.periodo.substring(0, 2) +
      "/" +
      "10/" +
      String(Number(proceso.periodo.substring(3, 5)) + 2000);

    const diezMesDate = new Date(diezMes);
    const anioDiezMes = diezMesDate.getFullYear();
    const mesDiezSinFormato = diezMesDate.getMonth() + 1;
    const mesDiezFormateado = String(mesDiezSinFormato).padStart(2, "0");

    const veinteMes =
      proceso.periodo.substring(0, 2) +
      "/" +
      "20/" +
      String(Number(proceso.periodo.substring(3, 5)) + 2000);

    const veinteMesDate = new Date(veinteMes);
    const anioVeinteMes = veinteMesDate.getFullYear();
    const mesVeinteSinFormato = veinteMesDate.getMonth() + 1;
    const mesVeinteFormateado = String(mesVeinteSinFormato).padStart(2, "0");

    const inicioAnioActual = new Date(anioActual, 0, 1);
    const xDiasDif1 =
      Math.floor((Ultimo - inicioAnioActual) / (1000 * 60 * 60 * 24)) + 1;
    const yearDiezSig = diezMesSiguiente.getFullYear();
    const inicioAnioDiezSig = new Date(yearDiezSig, 0, 1);
    const xDiasDif2 =
      Math.floor(
        (diezMesSiguiente - inicioAnioDiezSig) / (1000 * 60 * 60 * 24)
      ) + 1;

    const fechaddmmyy =
      diaActualFormateado +
      mesActualFormateado +
      String(Number(anioActual) - 2000);

    const fechayyyymmdd =
      anioActual + mesActualFormateado + diaActualFormateado;
    const fechayyyymmdd10 =
      anioActual10 + mesActual10Formateado + diaActual10Formateado;

    const periodoProximo = calcularSiguientePeriodo();

    const periodoProximoYYMM =
      "20" + periodoProximo.substring(3, 5) + periodoProximo.substring(0, 2);

    const nuMes = new Date("01/" + periodoProximo).getMonth() + 1;
    let nombreMes = null;

    if (nuMes === 1) {
      nombreMes = "Enero";
    }
    if (nuMes === 2) {
      nombreMes = "Febrero";
    }
    if (nuMes === 3) {
      nombreMes = "Marzo";
    }
    if (nuMes === 4) {
      nombreMes = "Abril";
    }
    if (nuMes === 5) {
      nombreMes = "Mayo";
    }
    if (nuMes === 6) {
      nombreMes = "Junio";
    }
    if (nuMes === 7) {
      nombreMes = "Julio";
    }
    if (nuMes === 8) {
      nombreMes = "Agosto";
    }
    if (nuMes === 9) {
      nombreMes = "Septiembre";
    }
    if (nuMes === 10) {
      nombreMes = "Octubre";
    }
    if (nuMes === 11) {
      nombreMes = "Noviembre";
    }
    if (nuMes === 12) {
      nombreMes = "Diciembre";
    }

    let cantidad = Number(procesos.data1) + Number(procesos.data2);

    let blobArchivo = new Blob([], {
      type: "text/plain;charset=utf-8",
    });

    let line1 =
      "01" +
      pad(cantidad, 9) +
      "T" +
      "64650001" +
      fechayyyymmdd +
      " ".repeat(172);

    blobArchivo = new Blob([blobArchivo, line1 + "\n"], {
      type: "text/plain;charset=utf-8",
    });

    let idFalso = 99990000;
    for (var i = 0; i < procesos.data3.length; i++) {
      const recordId = pad(procesos.data3[i].id, 8);
      const itemDescripcion =
        procesos.data3[i].itemscomprobantes[0].descripcion;
      let xdetalleServicio = itemDescripcion.substring(0, 20);
      xdetalleServicio = xdetalleServicio.replace(/[^a-zA-Z0-9]/g, "");
      const xNombre = procesos.data3[i].afiliados.nombre_razonsocial
        .trim()
        .substring(0, 40)
        .trim();

      const periodYYMM =
        "20" +
        procesos.data3[i].periodo.substring(3, 5) +
        procesos.data3[i].periodo.substring(0, 2);
      const importeEntero = Math.floor(procesos.data3[i].total);
      const importeDecimal = (
        (procesos.data3[i].total - importeEntero) *
        100
      ).toFixed(0);

      let bGrupo;
      if (procesos.data3[i].afiliados.id_formapago === 2) {
        bGrupo = 8;
      } else {
        if (procesos.data3[i].afiliados.id_formapago === 10) {
          bGrupo = 9;
        } else {
          bGrupo = 7;
        }
      }

      const bEmpresa = "646";
      const bImporte = pad(importeEntero, 6) + pad(importeDecimal, 2);
      const bJuliano1 =
        pad(String(anioActual).slice(-2), 2) + pad(xDiasDif1, 3);
      const bJuliano2 =
        pad(String(yearDiezSig).slice(-2), 2) + pad(xDiasDif2, 3);
      const bTitular = procesos.data3[i].id_titular.substring(1, 8);
      const titularId = pad(procesos.data3[i].id_titular, 21);
      let bPeriodo =
        procesos.data3[i].periodo.substring(0, 2) +
        procesos.data3[i].periodo.substring(3, 5);

      let barra =
        bEmpresa +
        bImporte +
        bJuliano1 +
        bTitular +
        bGrupo +
        bImporte +
        bJuliano2 +
        bPeriodo;

      let indice = 1;
      let privez = 0;
      let total = 0;

      for (let j = 0; j < barra.length; j++) {
        // Usamos índice base 0 en JS (j=0 a 40)
        if (privez !== 0) {
          if (indice > 9) {
            indice = 3;
          }
        } else {
          privez = 1;
        }
        total = total + Number(barra[j]) * indice;
        indice = indice + 2;
      }
      let dx2 = total / 2;
      let entero = Math.floor(dx2);
      let digito = entero % 10;

      // Resultado final
      barra = barra.trim() + String(digito).trim();

      line1 =
        "02" +
        titularId +
        recordId +
        " ".repeat(22) + // Space(22)
        periodYYMM +
        xdetalleServicio.padEnd(20, " ") + // xdetalleServicio & Space(20 - Len(xdetalleServicio))
        xNombre.padEnd(40, " ") + // xNombre & Space(40 - Len(xNombre))
        barra.padEnd(55, " ") + // barra & Space(55 - Len(barra))
        fechayyyymmdd +
        fechayyyymmdd10 +
        "T" +
        " ".repeat(9); // Space(9)

      blobArchivo = new Blob([blobArchivo, line1 + "\n"], {
        type: "text/plain;charset=utf-8",
      });

      if (procesos.data3[i].periodo === proceso.periodo) {
        idFalso = idFalso + 1;
        const recordId = pad(idFalso, 8);
        xdetalleServicio = (
          "CUOTA MES DE " +
          nombreMes +
          " DE " +
          String(Number(periodoProximo.substring(3, 5)) + 2000)
        ).substring(0, 20);

        bPeriodo =
          periodoProximo.substring(0, 2) + periodoProximo.substring(3, 5);

        barra =
          bEmpresa +
          bImporte +
          bJuliano1 +
          bTitular +
          bGrupo +
          bImporte +
          bJuliano2 +
          bPeriodo;

        indice = 1;
        privez = 0;
        total = 0;

        for (let j = 0; j < barra.length; j++) {
          // Usamos índice base 0 en JS (j=0 a 40)
          if (privez !== 0) {
            if (indice > 9) {
              indice = 3;
            }
          } else {
            privez = 1;
          }
          total = total + Number(barra[j]) * indice;
          indice = indice + 2;
        }
        dx2 = total / 2;
        entero = Math.floor(dx2);
        digito = entero % 10;

        barra = barra.trim() + String(digito).trim();

        line1 =
          "02" +
          titularId +
          recordId +
          " ".repeat(22) + // Space(22)
          periodoProximoYYMM +
          xdetalleServicio.padEnd(20, " ") + // xdetalleServicio & Space(20 - Len(xdetalleServicio))
          xNombre.padEnd(40, " ") + // xNombre & Space(40 - Len(xNombre))
          barra.padEnd(55, " ") + // barra & Space(55 - Len(barra))
          fechayyyymmdd +
          fechayyyymmdd10 +
          "T" +
          " ".repeat(9); // Space(9)

        blobArchivo = new Blob([blobArchivo, line1 + "\n"], {
          type: "text/plain;charset=utf-8",
        });
      }
    }

    saveAs(blobArchivo, "00000646" + "_" + fechayyyymmdd + ".ONL");

    // Pago Mis Cuentas

    blobArchivo = new Blob([], {
      type: "text/plain;charset=utf-8",
    });

    idFalso = 99990000;
    let totalDebe = 0;

    line1 = "04004798" + fechayyyymmdd + " ".repeat(264);

    blobArchivo = new Blob([blobArchivo, line1 + "\n"], {
      type: "text/plain;charset=utf-8",
    });

    for (var i = 0; i < procesos.data3.length; i++) {
      const recordId = pad(procesos.data3[i].id, 8);
      const itemDescripcion =
        procesos.data3[i].itemscomprobantes[0].descripcion;
      let xdetalleServicio = itemDescripcion.substring(0, 40);
      xdetalleServicio = xdetalleServicio.replace(/[^a-zA-Z0-9]/g, "");
      let xdetalleServicioCorto = itemDescripcion.substring(0, 15);
      xdetalleServicioCorto = xdetalleServicioCorto.replace(
        /[^a-zA-Z0-9]/g,
        ""
      );

      const xNombre = procesos.data3[i].afiliados.nombre_razonsocial
        .trim()
        .substring(0, 40)
        .trim();

      const periodYYMM =
        "20" +
        procesos.data3[i].periodo.substring(3, 5) +
        procesos.data3[i].periodo.substring(0, 2);

      const periodyyyymmdd10 = `${anioDiezMes}${mesDiezFormateado}10`;
      const periodyyyymmdd20 = `${anioDiezMes}${mesDiezFormateado}20`;
      const periodyyyymmddUltimo = `${anioUltimo}${mesUltimoFormateado}${dayUltimo}`;

      totalDebe = Number(totalDebe) + Number(procesos.data3[i].total);
      const importeEntero = Math.floor(procesos.data3[i].total);
      const importeDecimal = (
        (procesos.data3[i].total - importeEntero) *
        100
      ).toFixed(0);

      const bEmpresa = "4798";
      const bImporte = pad(importeEntero, 9) + pad(importeDecimal, 2);
      const bJuliano1 =
        pad(String(anioActual).slice(-2), 2) + pad(xDiasDif1, 3);
      const bJuliano2 =
        pad(String(yearDiezSig).slice(-2), 2) + pad(xDiasDif2, 3);
      const bTitular = pad(procesos.data3[i].id_titular, 7);
      const titularId = pad(procesos.data3[i].id_titular, 8);
      let bPeriodo =
        procesos.data3[i].periodo.substring(0, 2) +
        procesos.data3[i].periodo.substring(3, 5);

      let barra =
        bEmpresa + bImporte + bJuliano1 + bJuliano2 + bTitular + bPeriodo;

      let indice = 1;
      let privez = 0;
      let total = 0;

      for (let j = 0; j < barra.length; j++) {
        // Usamos índice base 0 en JS (j=0 a 40)
        if (privez !== 0) {
          if (indice > 9) {
            indice = 3;
          }
        } else {
          privez = 1;
        }
        total = total + Number(barra[j]) * indice;
        indice = indice + 2;
      }
      let dx2 = total / 2;
      let entero = Math.floor(dx2);
      let digito = entero % 10;

      // Resultado final
      barra = barra.trim() + String(digito).trim();

      line1 =
        "5" +
        titularId +
        " ".repeat(11) +
        recordId +
        " ".repeat(12) +
        "0" +
        periodyyyymmdd10 +
        bImporte +
        periodyyyymmdd20 +
        bImporte +
        periodyyyymmddUltimo +
        bImporte +
        "0".repeat(19) +
        titularId +
        " ".repeat(11) +
        xdetalleServicio.padEnd(40, " ") +
        xdetalleServicioCorto.padEnd(15, " ") +
        barra.padEnd(60, " ") +
        "0".repeat(29);

      blobArchivo = new Blob([blobArchivo, line1 + "\n"], {
        type: "text/plain;charset=utf-8",
      });
    }

    let cant = pad(Number(procesos.data2), 7);
    let importeEnteroDebe = Math.floor(totalDebe);
    const importeDecimalDebe = ((totalDebe - importeEnteroDebe) * 100).toFixed(
      0
    );
    let fImporte = pad(importeEnteroDebe, 14) + pad(importeDecimalDebe, 2);

    line1 =
      "94004798" +
      periodyyyymmdd +
      cant +
      "0".repeat(7) +
      fImporte +
      "0".repeat(234);

    blobArchivo = new Blob([blobArchivo, line1 + "\n"], {
      type: "text/plain;charset=utf-8",
    });

    saveAs(blobArchivo, "FAC4798." + fechaddmmyy);
  };

  //console.log(empresas);
  //console.log(serviciosFinalizadosExcel);

  return (
    <Fragment>
      <Menu />
      <Toast ref={toast} />
      <ConfirmDialog />
      {statusAcceso === 0 ? <Spinner /> : null}
      {statusAcceso === 400 ? accesoDenegado() : null}
      {statusAcceso === 200 ? (
        <Fragment>
          <Dialog
            header={renderHeaderProceso()}
            visible={visibleProceso}
            closable={false}
            footer={renderFooterProceso()}
            breakpoints={{ "960px": "75vw" }}
            style={{ width: "70vw", paddingBottom: "0" }}
            position="top"
          >
            <Grid container spacing={3} style={{ marginTop: "1vw" }}>
              <Grid item xs={12} md={4}>
                <label htmlFor="periodo">Período</label>
                <InputMask
                  id="periodo"
                  mask="99/99"
                  value={proceso ? proceso.periodo : null}
                  placeholder="99/99"
                  size={4}
                  onChange={(e) =>
                    guardarProceso({
                      ...proceso,
                      periodo: e.value,
                    })
                  }
                  style={{ marginLeft: "0.7vw", marginTop: "0.4vw" }}
                ></InputMask>
              </Grid>
              <button
                id="generarProceso"
                type="button"
                onClick={(e) => {
                  generar();
                }}
                style={{ display: "none" }}
              >
                Imprimir Facturas
              </button>
            </Grid>
          </Dialog>
        </Fragment>
      ) : null}

      <Grid item xs={12} sm={12}></Grid>
    </Fragment>
  );
}

/* class="MuiDataGrid-cell MuiDataGrid-cellLeft" */
